//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {AppLayout} from 'app_components/layouts/app'
//@end

// @ADD Component types
interface IProfileScreenLayoutProps {
  onHandleGoToPage: any
}

const ProfileScreenLayout: React.FC<IProfileScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppLayout>
      <div className='container mt-3'>
        {t('sandbox.profile.welcome')}

        <div className='mt-4'>
          <button onClick={props.onHandleGoToPage} className='btn btn-primary mr-3'>
            {t('sandbox.profile.return')}
          </button>
        </div>
      </div>
    </AppLayout>
  )
}

export default ProfileScreenLayout
